{
  "Add a new card": "Voeg een nieuwe card toe",
  "Add a new ACH account": "Voeg een nieuwe ACH-rekening toe",
  "Bank": "Bank",
  "Visa": "Visum",
  "Mastercard": "Mastercard",
  "Discover": "Ontdek",
  "Amerian Express": "American Express",
  "Auto-Pay On": "Automatische Betaling Aan",
  "Auto-Pay Off": "Automatische Betaling Uit",
  "Payment Method Missing": "Betalingsmethode Ontbreekt",
  "Home": "Thuis",
  "Reserve": "Reserveer",
  "Menu & Events": "Menu & Evenementen",
  "Billing": "Facturatie",
  "Sign Out": "Afmelden",
  "Issued Date": "Uitgiftedatum",
  "Invoice Number": "Factuurnummer",
  "Description": "Beschrijving",
  "Invoice Payment Amount": "Factuur Betalingsbedrag",
  "Due Date": "Vervaldatum",
  "Status": "Status",
  "invoiceEmptyState": "U heeft momenteel geen onbetaalde facturen hier.",
  "Payment Due": "Te Betalen",
  "Late": "Laat",
  "Paid": "Betaald",
  "Processing": "Verwerking",
  "Failed": "Mislukt",
  "Voided": "Geannuleerd",
  "Member Benefits": "Leden Voordelen",
  "Meeting Room": "Vergaderruimte",
  "Office": "Kantoor",
  "Desk": "Bureau",
  "Open Workspace": "Open Werkruimte",
  "New": "Nieuw",
  "Your Profile": "Jouw Profiel",
  "Company Profile": "Bedrijfsprofiel",
  "Member Management": "Ledenbeheer",
  "FAQ": "Veelgestelde Vragen",
  "Notification Settings": "Meldingsinstellingen",
  "Refer a Friend": "Verwijs een Vriend",
  "beta": "beta",
  "Something Went Wrong": "Er Is Iets Misgegaan",
  "Page Not Found": "Pagina Niet Gevonden",
  "Please refresh the page and try again.": "Vernieuw de pagina alstublieft en probeer het opnieuw.",
  "Please try our home page.": "Probeer alstublieft onze startpagina.",
  "Refresh": "Vernieuwen"
}
